module.exports = __webpack_public_path__ + "assets/4a0cff77c0da50109657eef26f46d26e.svg";